import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import swal from 'sweetalert2';

import { PartyNameModel } from '../../../model/index';
import { PartyNameService } from '../../../services/index';
import { AddEditPartyNameComponent } from './addEditPartyName.component';

@Component({
    selector: 'partyName-tab',
    templateUrl: './partyName.component.html',
})
export class PartyNameMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    partyNameData: PartyNameModel[];
    isLoading: boolean = false;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    filterData = {
        search_data: ''
    };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(
        private partyNameService: PartyNameService,
        private modalService: BsModalService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'NAME', prop: 'partyName', width: 370, minWidth: 370, maxWidth: 370 },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 70, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging) { return; }
        this.page.offset = pageInfo.offset;
        this.getPartyNameList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getPartyNameList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    onOpenedFilter(): void {
        setTimeout(function() { $('#filterSearch').focus(); }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getPartyNameList();
    }

    clearFilter(): void {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getPartyNameList();
    }

    getPartyNameList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.partyNameService
            .getPartyNameList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.partyNameData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditPartyName(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditPartyNameComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' PartyName Details';
        this.bsModalRef.content.partyNamedata = Object.assign({}, row);
        this.bsModalRef.content.partyNameLoadEvent.subscribe(($e) => {
            that.getPartyNameList();
        });
    }

    onDeletePartyName(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover PartyName: ' + row.partyName + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.partyNameService
                .deletePartyName(row.partyID)
                .then(function(res: any) {
                    if (res.success) {
                        that.getPartyNameList();
                        swal('Deleted', res.message, 'success');
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        }, function(dismiss) { });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/partyName/partyName.component.ts